import { meetingRoomService } from '@/services/app/meetingRoom.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { meetingRoomModel } from '@/models/app/meetingRoom.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const MEETING_ROOM_MODULE = "app/meetingRoom";

// ACTIONS
export const GET_ALL_MEETING_ROOM = 'getAllMeetingRoom';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_MEETING_ROOM_SUCCESS = "allMeetingRoomSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_MEETING_ROOM]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return meetingRoomService
            .getAll(filter)
            .then((result) => {
                commit(ALL_MEETING_ROOM_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_MEETING_ROOM_SUCCESS](state, {data}) {
        let meetingRoomList = data.data || [];
        state.list.data = meetingRoomList;
        if (data.pagination) state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = meetingRoomList.map(item => meetingRoomModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};
